import React from "react"
import { Button, Row, Col } from "antd"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { ExperienceCard } from "ui/ExperienceCard"
import { PlusOutlined } from "@ant-design/icons"
import experiencesSVG from "assets/imagesV2/experiences.svg"
import styles from "./ExperiencesHome.module.css"
import { EXPERIENCE_STATES } from "./constants"
import { useExperiencesActions } from "../../../../hooks/useExperiencesActions"
import { getEmptyStateTranslations } from "utils/translations"

const EmptyState = ({ onAddNewExperience, type }) => {
  const { t } = useTranslation()
  const translationKey = getEmptyStateTranslations(type)

  return (
    <div className={styles.emptyState}>
      <div className={styles.imgWrapper}>
        <img src={experiencesSVG} alt="" height="100px" width="auto" />
      </div>
      <Text className="mb-s" variant="sub" size="lg">
        {t(translationKey.info)}
      </Text>
      <Text className="mb-xxl" variant="body">
        {t(translationKey.subtitle)}
      </Text>
      {type === EXPERIENCE_STATES.published && (
        <Button type="primary" size="large" icon={<PlusOutlined />} onClick={onAddNewExperience}>
          {t("experiences.empty_state.add")}
        </Button>
      )}
    </div>
  )
}

export const TabContent = ({ trips, onAddNewExperience, type }) => {
  const { handleDelete, handleDuplicate,handleDeactivate, modal } = useExperiencesActions()
  if (trips.length === 0) {
    return <EmptyState onAddNewExperience={onAddNewExperience} type={type} />
  }

  const handleDuplicateAction = (trip) => {
    if (type === EXPERIENCE_STATES.published) {
      handleDuplicate(trip)
    }
  }

  return (
    <>
      <Row gutter={[20, 20]}>
        {trips.map((trip) => (
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={12} key={trip.id}>
            <ExperienceCard 
              trip={trip} 
              onDelete={() => handleDelete(trip)}
              onDeactivate={() => handleDeactivate(trip)}
              onDuplicate={() => handleDuplicateAction(trip)}
            />
          </Col>
        ))}
      </Row>
      {modal}
    </>
  )
}
